export const CONTACT = {
  company: "SkandaSri Eventz",
  by: "By LeoFair Events & Entertainments",
  phone: "+91 93531 28887",
  tel: "+919353128887",
  wa: "919353128887",
  email: "Skandasrieventz@gmail.com",
  address: "Sri Sai Estates, #287 & 288, 6th Block, BEL Layout, Vidyaranyapuram - 560097",
};

const isMobile = () => typeof navigator !== "undefined" && /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

// Phones open the WhatsApp app; desktops open WhatsApp Web straight into the chat.
export const waLink = (text) => {
  const t = encodeURIComponent(text);
  return isMobile() ? `https://wa.me/${CONTACT.wa}?text=${t}` : `https://web.whatsapp.com/send?phone=${CONTACT.wa}&text=${t}`;
};

export const MAIN = [
  { slug: "mini-decors", name: "Mini Decors", desc: "6/10 décor with side Thomala — our signature piece for poojas and functions.", cover: "/brand/cover-mini-decors.jpg?v=4" },
  { slug: "garlands", name: "Garlands", desc: "Fresh garlands made to order for every occasion.", cover: "/brand/cover-garlands.jpg?v=4", pos: "50% 70%" },
  { slug: "dindu", name: "Dindu", desc: "Flower-dressed Dindu for stage and seating décor.", cover: "/brand/cover-dindu.jpg?v=4" },
  { slug: "thomala", name: "Thomala", desc: "Fresh hand-made Thomala for pooja, weddings and festivals.", cover: "/brand/cover-thomala.jpg?v=4", pos: "50% 0%", note: "Each Thomala may vary in length, with a minimum measurement of 5 to 6.5 feet. For any customization requests, please feel free to contact us." },
  { slug: "loose-flowers", name: "Loose Flowers", desc: "Fresh loose flowers for pooja and decoration.", cover: "/brand/cover-loose-flowers.jpg?v=4" },
  { slug: "door-decor", name: "Door Decor", desc: "Thomala door décor, 3–3.5 ft.", cover: "/brand/cover-door-decor.jpg?v=4", pos: "50% 15%" },
  { slug: "tied-flowers", name: "Tied Flowers", desc: "Fresh flowers tied in strings, ready to use.", cover: "/brand/cover-tied-flowers.jpg?v=4" },
];

export const FESTIVE = { slug: "festive-offers", name: "Special Festive Offers", desc: "Hand-picked Thomala, Dindu, lotus garlands, loose flowers and tied flowers for Diwali and Varamahalakshmi.", festive: true };
export const NAV = [FESTIVE, ...MAIN];

export const SPECS = {
  "tied-flowers": { label: "Length", options: ["1.8 m", "3.6 m", "7.2 m", "9 m", "12.6 m", "18 m"], default: "1.8 m" },
  "loose-flowers": { label: "Weight", options: ["1 kg", "2 kg", "5 kg"], default: "1 kg" },
};

export const findCategory = (slug) => NAV.find((c) => c.slug === slug) || null;

export const ALL_OPTIONS = MAIN.map((c) => ({ slug: c.slug, label: c.name }));
